export default "__VITE_ASSET__D$2gp8pP__"